document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-mobile-menu]').forEach(btn=>btn.addEventListener('click',()=>{
    const nav=document.querySelector('[data-mobile-nav]'); if(!nav)return; const open=nav.style.display==='block'; nav.style.display=open?'none':'block'; btn.setAttribute('aria-expanded',String(!open));
  }));
  document.querySelectorAll('[data-slider]').forEach(slider=>{
    const track=slider.querySelector('[data-track]'), slides=[...slider.querySelectorAll('[data-slide]')], dots=[...slider.querySelectorAll('[data-dot]')]; if(slides.length<2)return;
    let i=0,timer; const show=n=>{i=(n+slides.length)%slides.length;track.style.transform=`translateX(-${i*100}%)`;dots.forEach((d,x)=>d.classList.toggle('is-active',x===i));};
    dots.forEach((d,x)=>d.addEventListener('click',()=>{show(x);restart()}));
    const restart=()=>{clearInterval(timer);timer=setInterval(()=>show(i+1),Number(slider.dataset.interval||5500));}; restart();
    slider.addEventListener('mouseenter',()=>clearInterval(timer));slider.addEventListener('mouseleave',restart);
  });
});
